<template lang="pug">
  .c-homepage__banner.col-24.relative.initBackgroundImage(:style="{backgroundImage:'url('+ img.banner +')'}")
    //- img.col-24.block.objectFitCover(:src="img.banner")
    .c-homepage__content.absolute.col-6
      img.block.col-24(:src="img.whiteLogo")
      h1.color-white.lineHeight2EM {{ text.bannerTitle }}
    .c-homepage__btn.absolute.color-white.cursorPointer(@click="loadMore")
      p.fontBold {{ text.findMore }}
      i.fa.fa-angle-down
    .c-homepage__language.cursorPointer.absolute.m-hidden(@click="stopPropagation($event);toggleLanguageChild()")
      p.relative
        | {{ defaultLanguage }}
        i.absolute(:class="languageActive == true ? 'fa fa-angle-up' : 'fa fa-angle-down'")
      .c-homepage__language--select.absolute(:class="{'is-active': languageActive == true}")
        p(v-for="(item, index) in languageList" :key="index" :class="{'is-active': defaultLanguage == item.name}" @click='stopPropagation($event); lang = item.value') {{ item.name }}

</template>

<script>
  export default {
    name: 'homepageBanner',
    props: ['content'],
    data(){
      return{
        text: {
          bannerTitle: this.$t('homepage.title'),
          findMore: this.$t('homepage.findMore'),
        },
        img: {
          banner: require('@/assets/img/homepage_banner.jpg'),
          whiteLogo: require('@/assets/img/logo_white.png'),
        },
        languageList: [
          { name: "中文", value: 'zh_cn'},
          // { name: "English", value: 'en_us'},
          // { name: "Deutsch", value: 'de_de'},
        ],
        languageDefault: localStorage.getItem('lang') || 'zh_cn',
        languageActive: false
      }
    },
    computed: {
      lang: {
        get () {
          return this.$i18n.locale
        },
        set (v) {
          this.languageActive = false
          if (v != this.languageDefault) {
            this.$i18n.locale = v
            this.languageDefault = v
            localStorage.lang = v
            window.location.reload()
          }
        },
      },
      defaultLanguage(){
        let name
        for (var i = 0; i < this.languageList.length; i++) {
          if (this.languageList[i].value == this.languageDefault) {
            name = this.languageList[i].name
          }
        }
        return name
      },
    },
    methods:{
      loadMore(){
        this.$parent.jumpToScroll(1)
      },
      closeLanguageChild(){
        this.languageActive = false
      },
      toggleLanguageChild(){
        this.languageActive = !this.languageActive
      },
      stopPropagation(e){
        if (e.stopPropagation) {
          e.stopPropagation();
        } else {
          e.cancelBubble = true;
        }
      },
    },
    created(){}
  }
</script>
